<template>
    <div id="memorial-list">
        <Content class="content-wrap">
            <div class="top-banner"></div>
            <div class="content-inner">
                <!--<div class="search-wrap">-->
                    <!--<Input placeholder="请输入逝者姓名" style="width: 200px">-->
                        <!--<Icon type="ios-search" color="blue" slot="suffix" />-->
                    <!--</Input>-->
                <!--</div>-->
                <div class="img-wrap">
                    <ul class="img-list">
                        <li class="img-item" :key="index" v-for="(item,index) in imgList" @click="selectDetail(item.memorialId)">
                            <div class="img-item-wrap" :style="{'background-image':'url('+(item.headImage||require('../../assets/noimgs.jpg'))+') '}">
                                <!--<img :src="item.headImage" alt="" class="img">-->
                                <!--<img :src="item.headImage" alt="" class="img">-->
                            </div>
                            <div class="name">{{item.deadName}}</div>
                        </li>
                    </ul>
                    <div class="no-data" v-if="imgList.length==0" >暂时没有数据</div>
                </div>
                <Page v-if="imgList && imgList.length" :page-size="pageInfo.pageSize" :total="total" show-total @on-change="pageChange" />
            </div>
        </Content>
    </div>
</template>

<script>
    import api from '../../api/api'
    export default {
        name: 'memorial',
        components: {

        },
        data(){
            return{
                imgList:[],
                total:'',
                pageInfo:{
                    page:0,
                    pageSize:12
                }
            }
        },
        activated(){
            this.getDeathList()
        },
        methods:{
            pageChange(index){
                this.pageInfo.page = index-1
                this.getDeathList()
            },
            getDeathList(){
                var self = this;
                api.getMemorialList(this.pageInfo).then(res=>{
                    self.imgList = res.rows;
                    self.total = res.total;
                }).catch(error =>{
                    this.$Message.error('列表数据获取错误')
                })
            },
            selectDetail(memorialId){
                this.$router.push({
                    path: `/memorialDetail/${memorialId}`
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    #memorial-list{
        background-color: #fff;
    }
    .content-wrap{
        padding-bottom: 40px;
    }
    .top-banner{
        width: 100%;
        height: 280px;
        text-align: center;
        position: relative;
        background: url('../../assets/images/bannner2.png') no-repeat center;
        background-size: cover;
    }
    .content-inner{
        max-width: 1200px;
        margin:0 auto;
        padding: 50px 40px ;
        .search-wrap{
            padding: 20px;
            text-align: right;
        }
        .img-wrap{
            .img-list{
                overflow: hidden;
                .img-item{
                    float: left;
                    margin:0 15px 15px 15px;
                    &:hover{
                        box-shadow:0 0 10px #999;
                        cursor: pointer;
                        .name{
                            color: #2d8cf0;
                        }
                    }
                    .img-item-wrap{
                        width: 250px;
                        height: 300px;
                        overflow: hidden;
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                        .img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .name{
                        text-align: center;
                        padding: 20px;
                        font-size: 18px;
                    }
                }
            }
        }
        .no-data{
            font-size: 24px;
        }
    }
</style>
